import { CircleNotch } from "@phosphor-icons/react";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

// ["numpy", "pandas", "matplotlib", "requests", "seaborn"]

export default function PythonOutput({
  code,
  extraLibs,
}: {
  code: string;
  extraLibs: string[];
}) {
  const [output, setOutput] = useState("");
  const [status, setStatus] = useState<"idle" | "running" | "loading">(
    "loading"
  );

  const workerRef = useRef<Worker | null>(null);

  useEffect(() => {
    const worker = new Worker("/pythonWorker.js");
    workerRef.current = worker;

    // İlk mesaj olarak paketleri gönder
    worker.postMessage({
      type: "init",
      packages: extraLibs,
    });

    worker.onmessage = (event) => {
      if (event.data.type === "ready") {
        setStatus("idle");
      } else if (event.data.type === "result") {
        setOutput(event.data.data);
        setStatus("idle");
      } else if (event.data.type === "error") {
        setOutput(`Error: ${event.data.data}`);
        setStatus("idle");
      }
    };

    return () => {
      worker.terminate();
    };
  }, []);

  const runCode = () => {
    if (!workerRef.current) return;

    setStatus("running");

    const timeout = setTimeout(() => {
      workerRef.current?.terminate();
      setOutput("Zaman aşımı: Kod çok uzun sürdü veya sonsuz döngü olabilir.");
      setStatus("idle");
    }, 20000);

    workerRef.current.onmessage = (event) => {
      clearTimeout(timeout);
      if (event.data.type === "result") {
        setOutput(event.data.result);
      } else if (event.data.type === "error") {
        setOutput("Hata: " + event.data.error);
      }
      setStatus("idle");
    };

    workerRef.current.postMessage({ type: "eval", code });
  };

  return (
    <div className="bg-surface-1 h-full relative">
      <button
        onClick={runCode}
        disabled={status !== "idle"}
        className={clsx(
          "absolute right-3 top-2 bg-myBlue rounded-2xl text-sm font-semibold py-1.5 cursor-pointer",
          status === "running" ? "px-1.5" : "px-3"
        )}
      >
        {status === "running" && (
          <CircleNotch weight="bold" className="animate-spin" size="20" />
        )}
        {status === "idle" && "Çalıştır"}
        {status === "loading" && <span className="animate-pulse">Paketler yükleniyor</span>}
      </button>
      <pre className="p-4 text-sm">{output}</pre>
    </div>
  );
}
